import * as React from "react";
import { ArrowRight, Compass, Key, Target } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const pathways = [{
  title: "Adventure Expeditions",
  description: "Uncover the raw beauty of Tayrona and the Aegean seas through expertly guided journeys that push the boundaries of discovery and personal growth.",
  icon: Compass,
  link: "/CurationPage"
}, {
  title: "Educational Exchanges",
  description: "Immersive cultural programs designed to foster global understanding, mentored by experts with decades of experience in international discovery.",
  icon: Target,
  link: "/CurationPage"
}, {
  title: "Philanthropic Impact",
  description: "Travel the world while saving the world. Join our mission to deliver humanitarian aid and support local communities in the destinations we love.",
  icon: Key,
  link: "/ImpactPage"
}];
export default function OurTrainingPathways() {
  return <section data-section-id="132136" id="bespoke-itineraries" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-serif text-secondary mb-4 tracking-widest uppercase !text-4xl font-light">IMMERSIVE LUXURY</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans">
            Curated experiences designed for the discerning traveler, blending deep local immersion with the refined luxury of PS Travel Company.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pathways.map((pathway, i) => {
          const Icon = pathway.icon;
          return <Card key={i} data-index={i} className="bg-card border-border/50 shadow-lg hover:shadow-primary/10 transition-all duration-500 flex flex-col h-full rounded-sm group">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-sm bg-primary/10 flex items-center justify-center mb-4 transition-colors group-hover:bg-primary/20">
                    <Icon className="w-6 h-6 text-primary" aria-hidden="true" />
                  </div>
                  <CardTitle className="text-xl text-secondary font-default uppercase tracking-wider">
                    {pathway.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow pb-6">
                  <p className="text-foreground/80 leading-relaxed font-sans">
                    {pathway.description}
                  </p>
                </CardContent>
                <CardFooter className="pt-0 mt-auto">
                  <Link to={pathway.link} className="text-primary hover:text-primary/80 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest transition-colors group">
                    View Details
                    <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}